package com.tregz.tremenz.ui.media

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.geometry.Rect
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.boundsInWindow
import androidx.compose.ui.layout.onGloballyPositioned
import com.tregz.tremenz.io.player.PlayerMedia
import kotlinx.browser.document
import kotlinx.browser.window

@Composable
actual fun MediaSurface(player: PlayerMedia, modifier: Modifier) {
    var bounds by remember { mutableStateOf<Rect?>(null) }
    val overlayTop = LocalPlayerOverlayTop.current
    val viewport = rememberMediaViewport()

    DisposableEffect(player) {
        val element = player.element
        if (element.parentElement == null) {
            document.body?.appendChild(element)
        }
        onDispose {
            element.remove()
        }
    }

    LaunchedEffect(bounds, overlayTop, viewport) {
        val b = bounds ?: return@LaunchedEffect
        val dpr = window.devicePixelRatio.takeIf { it > 0 } ?: 1.0
        val element = player.element
        val topPx = (b.top / dpr).toInt()
        val heightPx = (b.height / dpr).toInt()

        element.style.left = "${(b.left / dpr).toInt()}px"
        element.style.top = "${topPx}px"
        element.style.width = "${(b.width / dpr).toInt()}px"
        element.style.height = "${heightPx}px"

        if (overlayTop != null) {
            val coveredPx = heightPx - overlayTop.value
            if (coveredPx >= heightPx - 1) {
                element.style.visibility = "hidden"
                element.style.setProperty("pointer-events", "none")
                element.style.setProperty("clip-path", "inset(0 0 100% 0)")
            } else if (coveredPx > 0) {
                if (player.isPlaying) {
                    element.style.visibility = "visible"
                }
                element.style.setProperty("pointer-events", "none")
                element.style.setProperty("clip-path", "inset(0 0 ${coveredPx.toInt()}px 0)")
            } else {
                if (player.isPlaying) {
                    element.style.visibility = "visible"
                }
                element.style.setProperty("pointer-events", "auto")
                element.style.setProperty("clip-path", "none")
            }
        } else {
            if (player.isPlaying) {
                element.style.visibility = "visible"
            }
            element.style.setProperty("pointer-events", "auto")
            element.style.setProperty("clip-path", "none")
        }
    }

    Box(
        modifier = modifier
            .background(Color.Black)
            .onGloballyPositioned { coordinates ->
                bounds = coordinates.boundsInWindow()
            }
    )
}
